/* Product tabs — monta a barra de abas e liga o carrossel de cada aba.

   Cada aba (blocks/product-tab.liquid) chega como um .tab-pane com data-*:
   titulo, posicao e se esta ligada. Aqui os botoes sao criados na ordem da
   posicao, e somem as abas sem titulo, desligadas ou sem card. No editor de
   temas a aba desligada continua aparecendo (marcada como hidden).

   O carrossel e o mesmo do slider-tabs-section: Swiper com a barra de
   progresso que tambem arrasta. */
(function () {
  'use strict';

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function initProductTabs(root) {
    if (root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var designMode = root.hasAttribute('data-design-mode');
    var nav = root.querySelector('[data-tabs-nav]');
    var arrows = nav.querySelector('.swiper-navigation-buttons');
    var prevEl = arrows.querySelector('.swiper-button-prev');
    var nextEl = arrows.querySelector('.swiper-button-next');
    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-tab-pane]'));
    var current = null;

    // Card sem produto deixa o wrapper da Shopify vazio; fora do editor ele
    // sairia como um slide em branco.
    if (!designMode) {
      root.querySelectorAll('.swiper-wrapper > .shopify-block').forEach(function (wrapper) {
        if (!wrapper.querySelector('.slider-item')) wrapper.remove();
      });
    }

    var tabs = panes
      .map(function (pane, index) {
        return {
          pane: pane,
          index: index,
          title: pane.dataset.tabTitle,
          position: parseInt(pane.dataset.tabPosition, 10) || 1,
          show: pane.dataset.tabShow === 'true',
          hasCards: !!pane.querySelector('.slider-item')
        };
      })
      .filter(function (tab) {
        if (!tab.title) return false;
        if (designMode) return true;
        return tab.show && tab.hasCards;
      })
      .sort(function (a, b) {
        return a.position - b.position || a.index - b.index;
      });

    if (tabs.length === 0) {
      // Nada para mostrar: a section inteira sai da pagina.
      if (!designMode) root.hidden = true;
      return;
    }

    tabs.forEach(function (tab) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tab-link' + (tab.show ? '' : ' is-hidden-tab');
      button.textContent = tab.title;
      button.addEventListener('click', function () {
        activate(tab);
      });
      nav.insertBefore(button, arrows);
      tab.button = button;
      tab.pane.tabRef = tab;
    });

    function activate(tab) {
      tabs.forEach(function (t) {
        t.button.classList.toggle('active', t === tab);
        t.pane.classList.toggle('active', t === tab);
      });
      startSwiper(tab.pane);
    }

    // ---- carrossel da aba ativa ----
    function startSwiper(pane) {
      if (current) current.destroy(true, true);
      current = null;

      var swiperEl = pane.querySelector('.swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      var track = pane.querySelector('.pcs-progress-track');
      var dot = pane.querySelector('.pcs-progress-dot');
      var dragging = false;

      var swiper = new Swiper(swiperEl, {
        // Cada card chega dentro do <div class="shopify-block"> da Shopify,
        // que e o filho direto do .swiper-wrapper — e ele que vira o slide.
        slideClass: 'shopify-block',
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        breakpoints: {
          320: { slidesPerView: 2, spaceBetween: 10 },
          768: { slidesPerView: 3, spaceBetween: 15 },
          1024: { slidesPerView: 4, spaceBetween: 20 }
        },
        navigation: { prevEl: prevEl, nextEl: nextEl },
        freeMode: true,
        mousewheel: { forceToAxis: true },
        keyboard: { enabled: true },
        watchSlidesProgress: true,
        on: {
          afterInit: updateDot,
          setTranslate: function (sw) {
            if (!dragging) updateDot(sw);
          },
          resize: updateDot
        }
      });
      current = swiper;

      function updateDot(sw) {
        if (!track || !dot || !sw) return;
        var p = clamp(sw.progress || 0, 0, 1);
        dot.style.transform = 'translate(' + p * (track.clientWidth - dot.clientWidth) + 'px, -50%)';
      }

      if (!track || !dot) return;

      // A barra tambem navega: clicar ou arrastar nela move o carrossel.
      function progressFromX(clientX) {
        var rect = track.getBoundingClientRect();
        var x = clientX - rect.left - dot.clientWidth / 2;
        return clamp(x / (rect.width - dot.clientWidth), 0, 1);
      }

      function clientXOf(e) {
        return e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
      }

      function onMove(e) {
        if (!dragging) return;
        if (e.cancelable) e.preventDefault();
        swiper.setProgress(progressFromX(clientXOf(e)), 0);
        updateDot(swiper);
      }

      function onUp() {
        dragging = false;
        dot.classList.remove('is-dragging');
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('touchmove', onMove);
      }

      function onDown(e) {
        dragging = true;
        dot.classList.add('is-dragging');
        if (e.cancelable) e.preventDefault();
        swiper.setProgress(progressFromX(clientXOf(e)), 0);
        updateDot(swiper);
        window.addEventListener('pointermove', onMove, { passive: false });
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('pointerup', onUp, { once: true });
        window.addEventListener('touchend', onUp, { once: true });
      }

      // O painel pode ser reativado varias vezes; troca o handler antigo.
      [track, dot].forEach(function (el) {
        if (el._tabsDown) {
          el.removeEventListener('pointerdown', el._tabsDown);
          el.removeEventListener('touchstart', el._tabsDown);
        }
        el.addEventListener('pointerdown', onDown, { passive: false });
        el.addEventListener('touchstart', onDown, { passive: false });
        el._tabsDown = onDown;
      });
    }

    activate(tabs[0]);

    // No editor, selecionar um card ou uma aba abre a aba dele.
    root.addEventListener('shopify:block:select', function (event) {
      var pane = event.target.closest('[data-tab-pane]');
      if (pane && pane.tabRef) activate(pane.tabRef);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-tabs]').forEach(initProductTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // O editor recria a section sem recarregar a pagina.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
